module.exports = __webpack_public_path__ + "img/clear-channel.52a512bb.png";